import { AppClientConfig } from '../schemas/ClientConfig.schema';
import { ICurrencyDataModel } from './currency.data-model';
import { IFormatterDataModel } from './formatter.data-model';
import { IFundDataModel } from './fund.data-model';
import { KpiResolutionStrategyEntry, KpiSourceCatalogEntry } from './kpi-source-hierarchy.data-model';
import { IMetricsConfigDataModel } from './metrics-config.data-model';
import { IObjectiveCategoryDataModel } from './objective-category.data-model';
import { IRoundDataModel } from './round.data-model';
import { TransactionType } from './transaction-type.data-model';
import { IUserDataModel } from './user.data-model';

export interface ISortableItem {
  sortOrder?: number;
}

export interface IGenericSortable extends ISortableItem {
  displayName: string;
  id: number;
  name: string;
  sortOrder: number;
}

export interface IAppConfigDataModel {
  clientConfig?: AppClientConfig;
  currencies: ICurrencyDataModel[];
  formatters: IFormatterDataModel<unknown>[];
  funds: IFundDataModel[];
  /** Fixed catalog of KPI provenance channels, in the API's default priority order. */
  kpiSources?: KpiSourceCatalogEntry[];
  /** The KPI resolution strategies an admin can choose from, default first. */
  kpiResolutionStrategies?: KpiResolutionStrategyEntry[];
  metricsConfig: IMetricsConfigDataModel;
  objectiveCategory: IObjectiveCategoryDataModel[];
  rounds: IRoundDataModel[];
  sectors: IGenericSortable[];
  teams: IGenericSortable[];
  transactionTypes: TransactionType[];
  users: IUserDataModel[];
  updatedAt: string; // This field won't be available until MAGGIE-4091 is completed.
}

export function createGenericSortableDataModel(overrides: Partial<IGenericSortable> = {}): IGenericSortable {
  return {
    displayName: '',
    id: -1,
    name: '',
    sortOrder: -1,
    ...overrides,
  };
}

export function sortGenericSortable(item1: ISortableItem, item2: ISortableItem) {
  if (item1.sortOrder !== undefined && item2.sortOrder !== undefined) {
    return item1.sortOrder - item2.sortOrder;
  }
  return item1.sortOrder ?? item2.sortOrder ?? 0;
}
